import * as Utils from "../utils";

// The `time` param: a time of day, asked for with a picker.
//
// Stores `HH:MM`, 24-hour — "09:30", "14:05" — and nothing else. A time of day
// is not an instant: pinning one to the day it happened to be entered on is how
// a stored value changes meaning at midnight, and how it crosses a day boundary
// on the way through UTC. A field that wants both halves is a `date` param with
// `format: "date-time"`.
//
// The widget is @repoflow/form-schema's `time`, which is react-datepicker in
// `showTimeSelectOnly` mode — the same picker the `date` param uses, so the two
// cost one dependency between them and look like each other on the form.
export const schema = [
  {
    id: "/Types/Param/Type/Time",
    type: "object",
    properties: {
      ...Utils.properties,
      // How far apart the offered times are. A choice rather than a constant
      // because the right answer belongs to the question: an appointment book
      // wants 15, a shift roster 30, a lab reading 5.
      //
      // A RANGE rather than an enum of the sensible values, which is what this
      // was first written as. form-schema's resolve() picks a widget from the
      // JSON Schema type before it looks at `enum` — a string with one gets the
      // select, a NUMBER with one gets the ordinary number input — so the enum
      // would have rendered as a box a person can type 7 into and be told, on
      // save, that 7 is not one of six values it never showed them. A minimum
      // and a maximum say the same thing in the form the widget can actually
      // present.
      //
      // Not required. Left out, it reaches the widget as undefined and the
      // widget falls back to the same 15 — a fallback that loses nothing, which
      // is why this is optional where the date param's `format` is not.
      interval: {
        label: "Offer a time every (minutes)",
        type: "number",
        minimum: 1,
        maximum: 120,
        default: 15,
      },
      // Same reasoning as the date param's: declared so the generated property
      // carries one, not offered, because the only default worth having is
      // "now" and a schema cannot say that.
      default: {
        label: "Default value",
        type: "string",
        default: "",
      },
    },
    required: [],
  },
];
